import moment from "moment";
export class Notification {
  constructor({
    id = Number.NaN,
    type = "",
    folder = {},
    organization = {},
    dateCreated = null,
    dateUpdated = null,
  } = {}) {
    this.id = id;
    this.type = type;
    this.folder = folder ? folder : {};
    this.organization = organization ? organization : {};
    this.dateCreated = dateCreated ? new Date(dateCreated) : null;
    this.dateUpdated = dateUpdated ? new Date(dateUpdated) : null;
  }

  get relativeDateCreated() {
    return moment(this.dateCreated).fromNow();
  }

  get content() {
    switch (this.type) {
      case "FOLDER_ASSIGNED":
        return "notifications.folder_assigned";
      case "STATUS_CHANGED":
        return "notifications.status_changed";
      case "UNASSIGN_COLLABORATOR":
        return "notifications.folder_unassigned";
      case "FOLDER_ARCHIVED":
        return "notifications.folder_archived";
      case "FORM_ANSWERED":
        return "notifications.cosmoform_answered";
      case "COURSE_ANSWERED":
        return "notifications.course_answered";
      case "OFFER_CONSULTED":
        return "notifications.offer_consulted";
      case "OFFER_VALIDATED":
        return "notifications.offer_validated";
      case "OFFER_REJECTED":
        return "notifications.offer_rejected";
      case "OFFER_SIGNED":
        return "notifications.offer_signed";
      case "MEMBER_SIGNED":
        return "notifications.member_signed";
      case "COMMENT_ADDED":
        return "notifications.comment_added";
      default:
        return "notifications.folder_archived";
    }
  }

  get icon() {
    switch (this.type) {
      case "FOLDER_ASSIGNED":
        return "$mdiAccountPlus";
      case "STATUS_CHANGED":
        return "$folderArrowLeftRight";
      case "UNASSIGN_COLLABORATOR":
        return "$mdiAccountMinus";
      case "FOLDER_ARCHIVED":
        return "$mdiArchive";
      case "FORM_ANSWERED":
        return "$textBoxEdit";
      case "COURSE_ANSWERED":
        return "$textBoxEdit";
      case "OFFER_CONSULTED":
        return "$mdiFileEyeOutline";
      case "OFFER_VALIDATED":
        return "$fileCheck";
      case "OFFER_REJECTED":
        return "$fileRejected";
      case "OFFER_SIGNED":
        return "$fileSign";
      case "MEMBER_SIGNED":
        return "$mdiDraw";
      case "COMMENT_ADDED":
        return "$mdiCommentMultiple";
      default:
        return "$mdiArchive";
    }
  }
}
